export default (to, from, next) => {
  if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
    // verify with firebase or jwt
    next()
  } else {
    localStorage.removeItem('currentUser')
    next('/user/login')
  }
}
